module.exports = __webpack_public_path__ + "img/get-coupon-side-btn.6a993142.png";